module.exports = __webpack_public_path__ + "9de3e9bf604f7fdd9c3032e194c53993.jpg";